import { Backdrop, Card, Grid } from "@mui/material";
import React from "react";
import MDBox from "./MDBox";
import ModalHeader from "./modal_header";

export default function Modal({ open, title, children, actions }) {
  return (
    <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
      <MDBox px={0} width="calc(100% - 2rem)" mx="auto">
        <Grid container spacing={1} justifyContent="center">
          <Grid item xs={12} sm={9} md={5} lg={6} xl={5}>
            <Card>
              <ModalHeader title={title} />
              <MDBox pt={4} pb={3} px={3} maxHeight="calc(100vh - 200px)" overflow="auto">
                {children}
              </MDBox>
              <MDBox pb={3} pt={1} px={3}>
                {actions}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </Backdrop>
  );
}
